import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  Button,
  Paper,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Input,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ModalContent from "../../Common/Modal";
import { ContainedButton } from "../../Common/Buttons";

const COPYTRADINGSERVICE = WEBSERVICE + "copyTrading";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 600,
  width: "90%",
  maxHeight: "90vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  borderRadius: 2,
  overflow: "auto",
  // Hide scrollbar
  scrollbarWidth: "none", // Firefox
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

export default function ManageApiKeysAndBots() {
  const theme = localStorage.getItem("theme");
  const userName = localStorage.getItem("user_name");
  const navigate = useNavigate();
  const { brokerBasicInfo, btncolor } = useSelector((state) => state);
  const [tabIndex, setTabIndex] = useState(0);
  const [allApiKeys, setAllApiKeys] = useState([]);
  const [allTradingBots, setAllTradingBots] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showInMarketplaceToggleStatus, setShowInMarketplaceToggleStatus] =
    useState(0);

  const [apiKeyName, setApiKeyName] = useState("");
  const [market, setMarket] = useState("");
  const [price, setPrice] = useState("");
  const [showInMarketplace, setShowInMarketplace] = useState(false);
  const [allowCopyTrading, setAllowCopyTrading] = useState(false);
  const [apiKeyId, setApiKeyId] = useState("");
  const [showCryptofollowField, setShowCryptofollowField] = useState(false);
  const [exchangeName, setExchangeName] = useState("");
  const [flag, setFlag] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [profileName, setProfileName] = useState(userName);
  const [description, setDescription] = useState("");
  const [minCapReq, setMinCapReq] = useState("");
  const [cryptos, setCryptos] = useState(""); // Initially, this value can be set dynamically
  const [paidStatus, setPaidStatus] = useState(false);
  const [subscriptionCharge, setSubscriptionCharge] = useState("");
  const [botName, setBotName] = useState("");
  const [botId, setBotId] = useState("");

  const [counterCurrency, setCounterCurrency] = useState([]);

  const handleProfileNameChange = (e) => setProfileName(e.target.value);
  const handleDescriptionChange = (e) => setDescription(e.target.value);
  const handleMinCapReqChange = (e) => setMinCapReq(e.target.value);
  const handleCryptosChange = (e) => setCryptos(e.target.value);
  const handleSubscriptionChargeChange = (e) =>
    setSubscriptionCharge(e.target.value);

  const handlePaidStatusChange = (event) =>
    setPaidStatus(event.target.value === "true");

  const handleClose = () => (
    setIsModalOpen(false),
    setProfileName(userName),
    setDescription(""),
    setMinCapReq(""),
    setPaidStatus(false),
    setSubscriptionCharge("")
  );

  useEffect(() => {
    getAPIKeys();
    getTradingBots();
  }, []);

  const getAPIKeys = async () => {
    try {
      const response = await axios.get(
        `${COPYTRADINGSERVICE}/apiKey/getManageCopyTradingApiKeyView/${localStorage.getItem(
          "userId"
        )}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      console.log("get all api keys", response.data.manageCopyTradingList);
      setAllApiKeys(response.data.manageCopyTradingList);
    } catch (error) {
      setError(error);
      console.error("Error fetching API keys:", error);
    } finally {
      setLoading(false);
    }
  };

  const getTradingBots = async () => {
    try {
      const response = await axios.get(
        `${COPYTRADINGSERVICE}/apiKey/getManageCopyTradingBotView/${localStorage.getItem(
          "userId"
        )}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );
      setAllTradingBots(response.data.manageCopyTradingList);
    } catch (error) {
      console.error("Error fetching trading bots:", error);
    }
  };

  const getPriceLabel = (isPayable) => {
    switch (isPayable) {
      case 0:
        return "Free";
      case 1:
        return "Paid";
      case 2:
        return "-";
      default:
        return "";
    }
  };

  const changeStatusShowInMarketplace = (key, event, flag) => {
    const newStatus = event.target.checked ? 1 : 0;
    setShowInMarketplaceToggleStatus(newStatus);

    const accessToken = localStorage.getItem("access_token");
    axios
      .get(
        `${COPYTRADINGSERVICE}/apiKey/updateManageCopyTradingShowInStatus/${key}/${newStatus}/${flag}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      )
      .then((response) => {
        if (response.data.error.error_data !== 0) {
          showToast("error", response.data.error.error_msg); // Using a simple alert for demonstration, you can replace this with your alert method
        } else {
          showToast("success", response.data.error.error_msg); // Success message
        }

        // Call the functions to refresh data
        getAPIKeys();
        getTradingBots();
      })
      .catch((error) => {
        console.error("Error updating status:", error);
      });
  };

  const changeSatusAllowInCopyTrading = async (key, event, flag) => {
    const allowCopyTradingStatus = event.target.checked ? 1 : 0;

    try {
      const response = await axios.get(
        `${COPYTRADINGSERVICE}/apiKey/updateManageCopyTradingAllowsStatus/${key}/${allowCopyTradingStatus}/${flag}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      console.log("response", response.data);

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        showToast("success", response.data.error.error_msg);
      }

      getAPIKeys();
      getTradingBots();
    } catch (error) {
      console.error("Error updating copy trading status:", error);
    }
  };

  const publishMarketplaceApi = (key) => {
    console.log("abcdreKey", key);
    setApiKeyName(key.apiKeyName);
    setMarket(key.marketType);
    setPrice(key.price || "Paid");
    setShowInMarketplace(key.showInMarketplace);
    setAllowCopyTrading(key.allowCopyTrading);
    setApiKeyId(key.apiKeyId);
    setExchangeName(key.exchange_name);
    setShowCryptofollowField(false); // Assuming false by default
    setFlag("API");
    setIsModalOpen(true);
  };

  const publishMarketplaceBot = (bot) => {
    console.log("hgfasBot", bot);
    setIsModalOpen(true);
    setBotName(bot?.botName);
    setMarket(bot.botMarketType);
    setPrice(bot.price ?? "Paid");
    setShowInMarketplace(bot.showInMarketplace);
    setAllowCopyTrading(bot.allowCopyTrading);
    setBotId(bot.botId);
    setCryptos(bot.assetMustHold);
    setExchangeName(bot.exchange_name);
    setShowCryptofollowField(true);
    setFlag("bot");
  };

  const handleSubmit = () => {
    addApiKeyFunc();
    handleClose();
  };

  const addApiKeyFunc = () => {
    if (flag === "API") {
      publishApiKey();
    } else {
      publishBotKey();
    }
  };

  const getBasecurrencyList = async () => {
    try {
      const response = await axios.get(
        `${WEBSERVICE}home/getAllCurrency/${brokerBasicInfo?.brokerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      setCounterCurrency(result.currencyList);
      setCryptos(result.currencyList[0]);
    } catch (error) {
      console.error("Error fetching base currencies:", error);
    }
  };

  const resetFields = () => {
    setApiKeyName("");
    setMarket("");
    setShowInMarketplace("");
    setAllowCopyTrading("");
    setProfileName("");
    setDescription("");
    setMinCapReq("");
    setCryptos("");
    setPaidStatus(1);
    setSubscriptionCharge("");
    setApiKeyId("");
    setExchangeName("");
    getBasecurrencyList();
  };

  const publishApiKey = async () => {
    // Field validation
    if (
      profileName.trim() === "" ||
      description.trim() === "" ||
      minCapReq === ""
    ) {
      showToast("error", "Please fill all the fields");
      return;
    }

    // Subscription charge validation
    if (paidStatus === 1 && subscriptionCharge === "") {
      showToast("error", "Please add monthly subscription charge");
      return;
    }

    const addApiKey = {
      apiKeyName: apiKeyName,
      botName: botName,
      marketType: market,
      showInMarketplace: showInMarketplace,
      allowCopyTrading: allowCopyTrading,
      traderName: profileName,
      description: description,
      miniumCapitalRequirement: parseFloat(minCapReq),
      followersCryptos: "",
      isPayable: paidStatus ? 1 : 0,
      monthlySubcriptionCharge: subscriptionCharge,
      customerId: localStorage.getItem("userId"),
      apiKeyId: apiKeyId,
      botId: 0,
      exchange_name: exchangeName,
    };

    console.log("addapikey", addApiKey);

    try {
      const response = await axios.post(
        `${COPYTRADINGSERVICE}/apiKey/addManageCopyTrading`,
        JSON.stringify(addApiKey),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;
      if (res.error.error_data === 0) {
        handleClose();
        resetFields();
        showToast("success", res.error.error_msg);
        getAPIKeys();
        getTradingBots();
      } else {
        handleClose();
        resetFields();
        getAPIKeys();
        getTradingBots();
        showToast("error", res.error.error_msg);
      }
    } catch (error) {
      showToast("error", "An error occurred while publishing the API key.");
      console.error(error);
    }
  };

  const publishBotKey = async () => {
    if (profileName === "" || description === "" || minCapReq === "") {
      showToast("error", "Please fill all the fields");
      return;
    }

    if (paidStatus === 1 && subscriptionCharge === "") {
      showToast("error", "Please add monthly subscription charge");
      return;
    }

    const addApiKey = {
      apiKeyName: "",
      botName: botName,
      marketType: market,
      showInMarketplace: showInMarketplace,
      allowCopyTrading: allowCopyTrading,
      traderName: profileName,
      description: description,
      miniumCapitalRequirement: parseFloat(minCapReq),
      followersCryptos: cryptos,
      isPayable: paidStatus ? 1 : 0,
      monthlySubcriptionCharge: subscriptionCharge,
      customerId: localStorage.getItem("userId"),
      apiKeyId: 0,
      botId: botId,
      exchange_name: exchangeName,
    };

    try {
      const response = await axios.post(
        `${COPYTRADINGSERVICE}/apiKey/addManageCopyTrading`,
        JSON.stringify(addApiKey),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        handleClose();
        resetFields();
        showToast("success", response.data.error.error_msg);
        getAPIKeys();
        getTradingBots();
      } else {
        handleClose();
        resetFields();
        getAPIKeys();
        getTradingBots();
        showToast("error", response.data.error.error_msg);
      }
    } catch (error) {
      console.error("Error while publishing bot key:", error);
      showToast("error", "Something went wrong!");
    }
  };

  return (
    <Paper className="my-2 mx-4 p-2 ">
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Manage Copy Trading</Typography>
          <ContainedButton
            variant="contained"
            startIcon={
              <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
            }
            className="m-1"
            onClick={() => navigate("/copy-trade")}
          >
            Back
          </ContainedButton>
        </Box>

        <Tabs
          value={tabIndex}
          onChange={(e, newValue) => setTabIndex(newValue)}
          textColor="inherit"
          indicatorColor="primary"
        >
          <Tab label="API Keys" />
          <Tab label="Trading Bots" />
        </Tabs>

        {tabIndex === 0 && (
          <Paper sx={{ mt: 2, overflow: "auto" }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {[
                    "Key Name",
                    "Exchange Name",
                    "Market",
                    "Price",
                    "Show in Marketplace",
                    "Allow Copy Trading",
                    "Publish",
                  ].map((text, i) => (
                    <TableCell key={i}>{text}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {allApiKeys.map((key) => (
                  <TableRow key={key.apiKeyId} align="center">
                    <TableCell>{key.apiKeyName}</TableCell>
                    <TableCell>{key.exchange_name}</TableCell>
                    <TableCell>{key.marketType}</TableCell>
                    <TableCell>{getPriceLabel(key.isPayable)}</TableCell>
                    <TableCell>
                      <Switch
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: btncolor, // custom thumb color
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: btncolor, // custom track color when checked
                            },
                        }}
                        checked={key.showInMarketplace === "1"}
                        onClick={
                          key.isPayable !== 2
                            ? (e) =>
                                changeStatusShowInMarketplace(
                                  key.apiKeyId,
                                  e,
                                  "apiKey"
                                )
                            : undefined
                        }
                        disabled={key.isPayable === 2}
                      />
                    </TableCell>
                    <TableCell>
                      <Switch
                        checked={key.allowCopyTrading === "1"}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: btncolor, // custom thumb color
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: btncolor, // custom track color when checked
                            },
                        }}
                        onClick={
                          key.isPayable !== 2
                            ? (e) =>
                                changeSatusAllowInCopyTrading(
                                  key.apiKeyId,
                                  e,
                                  "apiKey"
                                )
                            : undefined
                        }
                        disabled={key.isPayable === 2}
                      />
                    </TableCell>
                    <TableCell>
                      <ContainedButton
                        variant="contained"
                        disabled={key.isPayable === 0 || key.isPayable === 1}
                        onClick={() => publishMarketplaceApi(key)}
                      >
                        Publish
                      </ContainedButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        )}

        {tabIndex === 1 && (
          <Paper sx={{ mt: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {[
                    "Bot Name",
                    "Exchange Name",
                    "Market",
                    "Price",
                    "Show in Marketplace",
                    "Allow Copy Trading",
                    "Publish",
                  ].map((text, i) => (
                    <TableCell key={i}>{text}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {allTradingBots
                  .sort((a, b) => Number(b.botId) - Number(a.botId))
                  .map((bot) => (
                    <TableRow key={bot.botId} align="center">
                      <TableCell>{bot.botName}</TableCell>
                      <TableCell>{bot.exchange_name}</TableCell>
                      <TableCell>{bot.botMarketType}</TableCell>
                      <TableCell>{getPriceLabel(bot.isPayable)}</TableCell>
                      <TableCell>
                        <Switch
                          checked={bot.showInMarketplace === "1"}
                          onClick={
                            bot.isPayable !== 2
                              ? (e) =>
                                  changeStatusShowInMarketplace(
                                    bot.botId,
                                    e,
                                    "bot"
                                  )
                              : undefined
                          }
                          disabled={bot.isPayable === 2}
                        />
                      </TableCell>
                      <TableCell>
                        <Switch
                          checked={bot.allowCopyTrading === "1"}
                          onClick={
                            bot.isPayable !== 2
                              ? (e) =>
                                  changeSatusAllowInCopyTrading(
                                    bot.botId,
                                    e,
                                    "bot"
                                  )
                              : undefined
                          }
                          disabled={bot.isPayable === 2}
                        />
                      </TableCell>
                      <TableCell>
                        <ContainedButton
                          variant="contained"
                          disabled={bot.isPayable === 0 || bot.isPayable === 1}
                          onClick={() => publishMarketplaceBot(bot)}
                        >
                          Publish
                        </ContainedButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </Paper>
        )}
      </Box>

      <ModalContent
        open={isModalOpen}
        onClose={handleClose}
        title={`Publish to Marketplace`}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <FormControl fullWidth margin="normal">
            <TextField
              label="Profile Name"
              variant="outlined"
              value={profileName}
              onChange={handleProfileNameChange}
              fullWidth
              required
              inputProps={{ maxLength: 30 }}
            />
          </FormControl>

          <FormControl fullWidth margin="normal">
            <TextField
              label="Description"
              variant="outlined"
              value={description}
              onChange={handleDescriptionChange}
              fullWidth
              required
              inputProps={{ maxLength: 100 }}
            />
          </FormControl>

          <FormControl fullWidth margin="normal">
            <TextField
              type="number"
              label="Min Capital Requirement"
              variant="outlined"
              value={minCapReq}
              onChange={handleMinCapReqChange}
              fullWidth
              required
              inputProps={{
                maxLength: 8,
                pattern: "^\\d*(\\.\\d*)?$",
              }}
            />
          </FormControl>

          {showCryptofollowField && (
            <FormControl fullWidth margin="normal">
              <TextField
                label="Cryptos the Followers must hold"
                variant="outlined"
                value={cryptos}
                onChange={handleCryptosChange}
                fullWidth
                readOnly
              />
            </FormControl>
          )}

          <FormControl component="fieldset" margin="normal">
            <FormLabel component="legend">Subscription Type</FormLabel>
            <RadioGroup
              value={paidStatus ? "true" : "false"}
              onChange={handlePaidStatusChange}
              row
            >
              <FormControlLabel value="true" control={<Radio />} label="Paid" />
              <FormControlLabel
                value="false"
                control={<Radio />}
                label="Free"
              />
            </RadioGroup>
          </FormControl>

          {paidStatus && (
            <FormControl fullWidth margin="normal">
              <TextField
                label="Subscription charges per month (In USDT)"
                variant="outlined"
                value={subscriptionCharge}
                onChange={handleSubscriptionChargeChange}
                fullWidth
                required
                inputProps={{ maxLength: 8, pattern: "[0-9]*" }}
              />
            </FormControl>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <ContainedButton variant="contained" type="submit">
              Confirm
            </ContainedButton>
          </div>
        </form>
      </ModalContent>
    </Paper>
  );
}
